// // src/Components/ServiceTooltip.jsx
// import React, { useState } from "react";
// import "./ServiceTooltip.css";

// const ServiceTooltip = ({ title, description }) => {
//   const [open, setOpen] = useState(false);

//   const handleToggle = () => setOpen(true);
//   const handleClose = (e) => {
//     if (e.target.classList.contains("tooltip-overlay")) setOpen(false);
//   };

//   return (
//     <>
//       <span
//         className="service-tooltip-trigger"
//         onClick={handleToggle}
//         title="Click for details"
//       >
//         <i className="fas fa-info-circle"></i>
//       </span>

//       {open && (
//         <div className="tooltip-overlay" onClick={handleClose}>
//           <div className="tooltip-box">
//             <h4>{title}</h4>
//             <p>{description}</p>
//             <button onClick={() => setOpen(false)} className="tooltip-close-btn">
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ServiceTooltip;






// import React, { useState, useEffect } from "react";
// import { useTranslation } from "react-i18next";
// import "./ServiceTooltip.css";

// const ServiceTooltip = ({ title, description }) => {
//   const { t } = useTranslation();
//   const [open, setOpen] = useState(false);

//   const handleToggle = () => setOpen(!open);
//   const handleClose = (e) => {
//     if (e.target.classList.contains("tooltip-overlay")) {
//       setOpen(false);
//     }
//   };

//   // Auto-close on escape key
//   useEffect(() => {
//     const handleEscape = (e) => {
//       if (e.key === "Escape") setOpen(false);
//     };
//     if (open) {
//       document.addEventListener("keydown", handleEscape);
//       return () => document.removeEventListener("keydown", handleEscape);
//     }
//   }, [open]);

//   // Parse description for structured content - focused on "When you need this service"
//   let content;
//   if (description.includes("\n")) {
//     const sections = description.split("\n\n").map((s) => s.trim()).filter(Boolean);
//     // Only process the first section as "When you need this service"
//     const whenSection = sections[0];
//     if (whenSection) {
//       const lines = whenSection.split("\n").map((l) => l.trim()).filter(Boolean);
//       const sectionTitle = lines[0];
//       const items = lines.slice(1).map((item) => item.replace(/^•\s*/, ""));
//       content = (
//         <div className="tooltip-section">
//           <h5>{sectionTitle}</h5>
//           <ul className="tooltip-bullets">
//             {items.map((item, i) => (
//               <li key={i}>{item}</li>
//             ))}
//           </ul>
//         </div>
//       );
//     }
//   } else {
//     // Fallback: simple paragraph if no structure
//     content = <p className="tooltip-description">{description}</p>;
//   }

//   return (
//     <>
//       <span
//         className="service-tooltip-trigger"
//         onClick={handleToggle}
//         aria-label="Service details"
//         role="button"
//         tabIndex={0}
//         onKeyDown={(e) => e.key === "Enter" && handleToggle()}
//       >
//         <i className="fas fa-info-circle" aria-hidden="true"></i>
//       </span>
//       {open && (
//         <div className="tooltip-overlay" onClick={handleClose} role="dialog" aria-modal="true">
//           <div className="tooltip-box">
//             <div className="tooltip-header">
//               <h4>{title}</h4>
//               <button
//                 onClick={() => setOpen(false)}
//                 className="tooltip-close-btn"
//                 aria-label="Close tooltip"
//               >
//                 <i className="fas fa-times" aria-hidden="true"></i>
//               </button>
//             </div>
//             <div className="tooltip-content">{content}</div>
//             <div className="tooltip-footer">
//               <button className="got-it-btn" onClick={() => setOpen(false)}>
//                 {/* Got it */}
//                 {t("tooltip.gotIt")}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ServiceTooltip;



// ***** New Update (2-Nov-2025) ***** //
// import React, { useState, useEffect } from "react";
// import { useTranslation } from "react-i18next";
// import "./ServiceTooltip.css";

// const ServiceTooltip = ({ title, description }) => {
//   const { t } = useTranslation();
//   const [open, setOpen] = useState(false);

//   const handleToggle = () => setOpen((v) => !v);
//   const handleClose = (e) => {
//     if (e.target.classList.contains("tooltip-overlay")) setOpen(false);
//   };

//   // Close on Escape
//   useEffect(() => {
//     const onEsc = (e) => e.key === "Escape" && setOpen(false);
//     if (open) {
//       document.addEventListener("keydown", onEsc);
//       return () => document.removeEventListener("keydown", onEsc);
//     }
//   }, [open]);

//   // --- Parse description into sections ---
//   // A "section" = heading line + bullet/paragraph lines.
//   // Sections are separated by blank lines.
//   const parseDescription = (text = "") => {
//     // Normalize newlines and split by blank lines
//     const blocks = String(text)
//       .replace(/\r\n/g, "\n")
//       .split(/\n{2,}/)
//       .map((b) => b.trim())
//       .filter(Boolean);

//     if (blocks.length === 0) return [];

//     return blocks.map((block) => {
//       const lines = block
//         .split("\n")
//         .map((l) => l.trim())
//         .filter(Boolean);

//       if (lines.length === 0) return null;

//       // First line = heading (capitalize if needed)
//       const heading = lines[0];

//       // Remaining lines = bullets (strip leading bullet chars if present)
//       const items = lines.slice(1).map((l) =>
//         l.replace(/^[-•*\u2022]\s*/, "")
//       );

//       return { heading, items };
//     }).filter(Boolean);
//   };

//   const sections = parseDescription(description);

//   return (
//     <>
//       <span
//         className="service-tooltip-trigger"
//         onClick={handleToggle}
//         aria-label="Service details"
//         role="button"
//         tabIndex={0}
//         onKeyDown={(e) => e.key === "Enter" && handleToggle()}
//       >
//         <i className="fas fa-info-circle" aria-hidden="true"></i>
//       </span>

//       {open && (
//         <div
//           className="tooltip-overlay"
//           onClick={handleClose}
//           role="dialog"
//           aria-modal="true"
//         >
//           <div className="tooltip-box">
//             <div className="tooltip-header">
//               <h4>{title}</h4>
//               <button
//                 onClick={() => setOpen(false)}
//                 className="tooltip-close-btn"
//                 aria-label="Close tooltip"
//               >
//                 <i className="fas fa-times" aria-hidden="true"></i>
//               </button>
//             </div>

//             <div className="tooltip-content">
//               {sections.length > 0 ? (
//                 sections.map((sec, idx) => (
//                   <div className="tooltip-section" key={idx}>
//                     <h5>{sec.heading}</h5>
//                     {sec.items.length > 0 ? (
//                       <ul className="tooltip-bullets">
//                         {sec.items.map((it, i) => (
//                           <li key={i}>{it}</li>
//                         ))}
//                       </ul>
//                     ) : (
//                       <p className="tooltip-description">
//                         {/* If no items, treat the "heading" block as a paragraph */}
//                         {sec.heading}
//                       </p>
//                     )}
//                   </div>
//                 ))
//               ) : (
//                 <p className="tooltip-description">{description}</p>
//               )}
//             </div>

//             <div className="tooltip-footer">
//               <button className="got-it-btn" onClick={() => setOpen(false)}>
//                 {t("tooltip.gotIt")}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ServiceTooltip;




// ***** New Update (7-Dec-2025) ***** //
// ***** New Update (2-Nov-2025) ***** //
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./ServiceTooltip.css";

const ServiceTooltip = ({ title, description }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleToggle = () => setOpen((v) => !v);
  const handleClose = (e) => {
    if (e.target.classList.contains("tooltip-overlay")) setOpen(false);
  };

  // Close on Escape
  useEffect(() => {
    const onEsc = (e) => e.key === "Escape" && setOpen(false);
    if (open) {
      document.addEventListener("keydown", onEsc);
      return () => document.removeEventListener("keydown", onEsc);
    }
  }, [open]);

  // 🔒 Lock background scroll while tooltip is open
  useEffect(() => {
    if (!open) return;

    const html = document.documentElement;
    const body = document.body;

    const previousHtmlOverflow = html.style.overflow;
    const previousBodyOverflow = body.style.overflow;

    html.style.overflow = "hidden";
    body.style.overflow = "hidden";

    return () => {
      html.style.overflow = previousHtmlOverflow;
      body.style.overflow = previousBodyOverflow;
    };
  }, [open]);

  // --- Parse description into sections ---
  // A "section" = heading line + bullet/paragraph lines.
  // Sections are separated by blank lines.
  const parseDescription = (text = "") => {
    // Normalize newlines and split by blank lines
    const blocks = String(text)
      .replace(/\r\n/g, "\n")
      .split(/\n{2,}/)
      .map((b) => b.trim())
      .filter(Boolean);

    if (blocks.length === 0) return [];

    return blocks
      .map((block) => {
        const lines = block
          .split("\n")
          .map((l) => l.trim())
          .filter(Boolean);

        if (lines.length === 0) return null;

        // First line = heading
        const heading = lines[0];

        // Remaining lines = bullets (strip leading bullet chars if present)
        const items = lines.slice(1).map((l) =>
          l.replace(/^[-•*\u2022]\s*/, "")
        );

        return { heading, items };
      })
      .filter(Boolean);
  };

  const sections = parseDescription(description);

  return (
    <>
      <span
        className="service-tooltip-trigger"
        onClick={handleToggle}
        aria-label="Service details"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && handleToggle()}
      >
        <i className="fas fa-info-circle" aria-hidden="true"></i>
      </span>

      {open && (
        <div
          className="tooltip-overlay"
          onClick={handleClose}
          role="dialog"
          aria-modal="true"
        >
          <div className="tooltip-box">
            <div className="tooltip-header">
              <h4>{title}</h4>
              <button
                onClick={() => setOpen(false)}
                className="tooltip-close-btn"
                aria-label="Close tooltip"
              >
                <i className="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>

            <div className="tooltip-content">
              {sections.length > 0 ? (
                sections.map((sec, idx) => (
                  <div className="tooltip-section" key={idx}>
                    <h5>{sec.heading}</h5>
                    {sec.items.length > 0 ? (
                      <ul className="tooltip-bullets">
                        {sec.items.map((it, i) => (
                          <li key={i}>{it}</li>
                        ))}
                      </ul>
                    ) : (
                      <p className="tooltip-description">
                        {/* If no items, treat the "heading" block as a paragraph */}
                        {sec.heading}
                      </p>
                    )}
                  </div>
                ))
              ) : (
                <p className="tooltip-description">{description}</p>
              )}
            </div>

            <div className="tooltip-footer">
              <button className="got-it-btn" onClick={() => setOpen(false)}>
                {t("tooltip.gotIt")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ServiceTooltip;
